import { ReactElement } from 'react'

import { SalesReportVariant } from '../../../../enums/salesReportVariant'
import { useSalesReportVariant } from '../../../../hooks/useSalesReportVariant'
import { SalesByCustomerReportExportActions } from './elements/SalesByCustomerReportExportActions'
import { SalesByItemReportExportActions } from './elements/SalesByItemReportExportActions'
import { SalesOverviewReportExportActions } from './elements/SalesOverviewReportExportActions'

export const SalesReportExportActions = (): ReactElement | null => {
  const { salesReportVariant } = useSalesReportVariant()

  switch (salesReportVariant) {
    case SalesReportVariant.Overview:
      return <SalesOverviewReportExportActions />
    case SalesReportVariant.ByItem:
      return <SalesByItemReportExportActions />
    case SalesReportVariant.ByCustomer:
      return <SalesByCustomerReportExportActions />
    default:
      return null
  }
}
